import { ButtonHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={clsx(
          `inline-flex outline-none focus-visible:ring focus-visible:ring-grey-60/50`,
          className,
        )}
        {...props}
      >
        {children}
      </button>
    );
  },
);
